export const ADD_CHARACTERS = 'ADD_CHARACTERS'
export const DEL_CHARACTERS = 'DEL_CHARACTERS'
export const ADD_CHARACTER_LIST = 'ADD_CHARACTER_LIST'
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE'
export const NEXT_PAGE  = 'PREVIOUS_NEXT'
export const RESET_PAGE = 'RESET_PAGE'